import { render, staticRenderFns } from "./flex-container.vue?vue&type=template&id=32f6ae16"
import script from "./flex-container.vue?vue&type=script&lang=js"
export * from "./flex-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports